module.exports = __webpack_public_path__ + "img/icon-scan.f9bab031.svg";